<template>
    <modal v-bind="$attrs"
           v-on="$listeners"
           class="product-order-modal"
    >
      <base-form @submit.prevent="submitForm" class="mb-0 px-0">
        <div class="flex items-center flex-col">
          <div class="col-12">
            <fg-input :label="$t('generic.jobBoard')"
                      required
                      :error="getError($t('generic.jobBoard'))">
              <JobBoardsForProductAutocomplete :disabled="!productSelected"
                                               :product-id="product.id"
                                               :name="$t('generic.jobBoard')"
                                               value-key="id"
                                               option-key="job_board"
                                               v-validate="'required'"
                                               v-model="selectedJobBoard">
              </JobBoardsForProductAutocomplete>
            </fg-input>
          </div>
          <div v-if="product.product_type === 'featured_employer'" class="col-12">
            <fg-input :label="$t('generic.organization')"
                      :placeholder="$t('generic.organization')"
                      :error="getError($t('generic.organization'))"
                      required>
              <organization-autocomplete v-model="selectedOrganization"
                                         v-validate="'required'"
                                         :name="$t('generic.organization')"
              >
              </organization-autocomplete>
            </fg-input>
          </div>
          <div class="col-12">
            <fg-input :label="$t('generic.paymentType')" required
                      :error="getError($t('generic.paymentType'))">
              <payment-type-select :disabled="!productSelected"
                                   :credits-amount="totalPriceCredits"
                                   :credits-balance="creditsBalance"
                                   :contracts-balance="contractsBalance"
                                   :name="$t('generic.paymentType')"
                                   v-model="selectedPayment"
                                   v-validate="'required|not_empty_object'">
              </payment-type-select>
            </fg-input>
          </div>
          <div class="col-12">
            <fg-input :placeholder="$t('generic.price')"
                      :name="$t('generic.price')"
                      :error="getError($t('generic.price'))"
                      :label="`${$t('generic.price')} (${currencySymbol})`"
                      v-validate="'required|min_value:0|numeric|'"
                      type="number"
                      v-model="price">
            </fg-input>
          </div>
          <div class="col-12">
            <fg-input :label="$t('generic.po_number')"
                      :name="$t('generic.po_number')"
                      v-model="po_number">
            </fg-input>
          </div>

        </div>
      </base-form>
    </modal>
</template>
<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import { Select, Option } from 'element-ui'
  import get from 'lodash/get'
  import PaymentTypeSelect from 'src/components/Autocomplete/PaymentTypeSelect'
  import JobBoardsForProductAutocomplete from 'src/components/Autocomplete/JobBoardsForProductAutocomplete'
  import ClientService from 'src/services/ClientService'
  import CountryAutocomplete from 'src/components/Autocomplete/CountryAutocomplete';
  import OrganizationAutocomplete from '@/components/Autocomplete/OrganizationAutocomplete'
  import VueGoogleAutocomplete from 'src/components/Autocomplete/VueGoogleAutocomplete'

  Vue.component(VueGoogleAutocomplete.name, VueGoogleAutocomplete);
  export default {
    inheritAttrs: false,
    components: {
      CountryAutocomplete,
      PaymentTypeSelect,
      OrganizationAutocomplete,
      JobBoardsForProductAutocomplete,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      product: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        selectedPayment: {},
        selectedJobBoard: null,
        selectedOrganization: null,
        creditsBalance: null,
        allContracts: [],
        client: {},
        po_number: '',
        price: 0,
        loading: false
      }
    },
    computed: {
      ...mapState({
        currentJob: state => state.jobs.currentJob,
        currencySymbol: state => state.config.currencySymbol
      }),
      productSelected() {
        return Object.keys(this.product).length > 0
      },
      pricePerCredit() {
        return this.$store.state.config.creditPrice
      },
      totalPriceCredits() {
        return this.product.credits || this.product.price/this.pricePerCredit
      },
      contractsBalance () {
        let contractsFilterFn = (contract) => {
          let board = this.selectedJobBoard;
          let matchesProduct = this.product.id === contract.id
          return board !== undefined && matchesProduct
        }
        let validAmounts = this.allContracts.filter(contractsFilterFn)
        return validAmounts.reduce((acc, contract) => acc + contract.amount, 0)
      }
    },
    methods: {
      async productChange(product) {
        this.price = product.price
        await this.getCreditsBalance()
      },
      onJobBoardSelect() {

      },
      async getCreditsBalance () {
        let clientId = this.$route.params.id
        let {data} = await ClientService.getClientCredits(clientId)
        this.creditsBalance = data.credits
      },
      async getContractsBalance () {
        let clientId = this.$route.params.id
        let {data} = await ClientService.getClientContractsBalance(clientId)
        this.allContracts = data
        if (!data){
          return
        }
        this.$emit('contracts-balance', data)
      },
      async getClient() {
        let clientId = this.$route.params.id
        let {data} = await ClientService.getById(clientId)
        this.client = data
      },
      async submitForm() {
        let valid = await this.$validator.validateAll()
        if (!valid) {
          return
        }
        try {
          this.loading = true
          let model = {
            product_job_board_id: this.selectedJobBoard.id,
            po_number: this.po_number,
            price: this.price,
            payment_type_id: this.selectedPayment.id,
          }
          if (this.product.product_type === 'featured_employer') {
            model.organisation_id = get(this.selectedOrganization, 'id')
          }
          await ClientService.createOrder(this.client.uuid, this.product.id, model)
          this.$notify({type: 'success', message: this.$t('order.success')})
          this.$emit('update:show', false)
        } catch(e) {
          console.warn(e)
        }
        this.loading = false
      }
    },
    async created() {
      await Promise.all([
        this.getCreditsBalance(),
        this.getContractsBalance(),
        this.getClient()
      ])
    },
    watch: {
      product:{
        immediate: true,
        handler: function(newVal) {
          this.price = newVal.price
        }
      }
    }
  }
</script>
<style lang="scss">
.product-order-modal {
  .modal-body,
  .modal-header {
    @apply p-0;
    @apply rounded;
  }
  .modal-body > div {
    padding: 0 !important;
  }
  .modal-body .card {
    @apply mb-0;
  }
  .modal-content {
    @apply overflow-hidden;
  }
}
</style>
